import { jwtDecode } from "jwt-decode";
import { loginSuccess } from "../../../store/slices/authSlice";

export default function responseSignUp(response: any, api: any, arg: any) {
    console.log("Response in responseSignUp handler:", response);
}